// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 20H16.9142L13.5 23.4142L10.0858 20H4L4 5L23 5V20ZM19 3.5H2.5L2.5 15.5H0.5L0.500001 1.5L19 1.5V3.5Z"}}]};

const TipsDoubleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tips-double-filled',
    ref,
    icon: element,
  },
));

TipsDoubleFilledIcon.displayName = 'TipsDoubleFilledIcon';

export default TipsDoubleFilledIcon;
